import type { NavigationError } from "@angular/router";
import * as Sentry from "@sentry/angular";

import { reloadOnChunkLoadError } from "./chunk-load-recovery";

/**
 * Router failures such as `NoMatch` reach GlitchTip without the URL that was being
 * navigated to, so it is recorded as a breadcrumb before the error is reported.
 */
export function handleNavigationError(navigationError: NavigationError): void {
  Sentry.addBreadcrumb({
    category: "navigation.error",
    level: "error",
    message: navigationError.url,
  });

  reloadOnChunkLoadError(navigationError);
}
